module.exports = __webpack_public_path__ + "a918fa54d6ecfc3154dda89a2598d1ce.png";